import React from 'react';
import ReactDOM from 'react-dom';
import { useModalStore } from 'src/hooks/useStore';

// 取得.html檔中要渲染內容的DOM物件，不存在的話自己建一個div(for typescript check)
const modal = document.getElementById('modal');
const portalDiv = modal ? modal : document.createElement('div');

const ModalLayout: React.FC = () => {
  const isModalOpen = useModalStore((state) => state.isModalOpen);
  const activeModal = useModalStore((state) => state.activeModal);
  return <>{isModalOpen && ReactDOM.createPortal(activeModal, portalDiv)}</>;
};

export default ModalLayout;
